// 調整舞台面板每一段（位置、方向、動作時間、依序開始）的開合：每位使用者記住自己的（存在這台電腦）。
// 同一段出現好幾次（一個物件有兩個機關）一起開合，所以放在元件外面。

export type SectionId = 'position' | 'spin' | 'timing' | 'seq';

/** 預設打開最常用的；進階的（依序開始）收起來 */
export const SECTION_DEFAULTS: Record<SectionId, boolean> = { position: true, spin: true, timing: true, seq: false };

type SectionMap = Partial<Record<SectionId, boolean>>;

const storageKey = (userId: string | null | undefined) => `sp_adjust_sections:${userId ?? 'guest'}`;
const cache = new Map<string, SectionMap>();
const listeners = new Set<() => void>();

function load(key: string): SectionMap {
  const hit = cache.get(key);
  if (hit) return hit;
  let map: SectionMap = {};
  try {
    const raw = localStorage.getItem(key);
    const parsed: unknown = raw ? JSON.parse(raw) : null;
    if (parsed && typeof parsed === 'object') map = parsed as SectionMap;
  } catch { /* 讀不到就用預設 */ }
  cache.set(key, map);
  return map;
}

/** 給 useSyncExternalStore：這位使用者現在的開合（沒動過的段不在裡面） */
export function sectionMap(userId: string | null | undefined): SectionMap {
  return load(storageKey(userId));
}

export function isSectionOpen(map: SectionMap, id: SectionId): boolean {
  return map[id] ?? SECTION_DEFAULTS[id];
}

export function setSectionOpen(userId: string | null | undefined, id: SectionId, open: boolean): void {
  const key = storageKey(userId);
  const next = { ...load(key), [id]: open };
  cache.set(key, next);
  try { localStorage.setItem(key, JSON.stringify(next)); } catch { /* 存不了就只記到關頁面 */ }
  listeners.forEach(l => l());
}

export function subscribeSections(l: () => void): () => void {
  listeners.add(l);
  return () => { listeners.delete(l); };
}

/** 測試用 */
export function resetSectionCache(): void {
  cache.clear();
}
